import styled from 'styled-components';

const DeliveryContainer = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold};
  color: ${({ theme }) => theme.colors.night_blue_1};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default DeliveryContainer;
